import { FACTORY_PURCHASE_AGREEMENT_PATH } from '../../lib/factory-purchase-agreement';

export default function FactoryPurchaseAgreementConsent({
  accepted,
  disabled,
  onChange,
}: {
  accepted: boolean;
  disabled: boolean;
  onChange: (accepted: boolean) => void;
}) {
  return (
    <section className="fx-agreement-consent" aria-label="发布采购协议确认">
      <h4>发布前签署采购协议</h4>
      <p>
        收入分成的实质是猴毛AI向开发者采购智能体技术服务：平台30%，开发者70%为技术服务采购价。
      </p>
      <ul>
        <li>你以独立技术服务提供者身份交付并持续维护智能体。</li>
        <li>你应确保技术成果、素材和数据处理合法合规且已获充分授权。</li>
        <li>用户款项由平台统一收取，开发者不取得平台收入或利润的所有权。</li>
      </ul>
      <label className="fx-agreement-checkbox">
        <input
          type="checkbox"
          checked={accepted}
          disabled={disabled}
          onChange={(event) => onChange(event.target.checked)}
        />
        <span>
          我已完整阅读、理解并同意
          <a href={FACTORY_PURCHASE_AGREEMENT_PATH} target="_blank" rel="noreferrer">
            《猴毛AI Agent Studio 智能体技术服务采购协议》
          </a>
        </span>
      </label>
      <p className="fx-fine">复选框不会默认勾选；每次发布新正式版本均须重新确认。</p>
    </section>
  );
}
